"use client";

import { useState } from "react";

import { cn } from "@/lib/utils";

export function ChannelActivityAvatar({
  imageUrl,
  initials,
  label,
  className,
}: {
  imageUrl: string | null;
  initials: string;
  label: string;
  className?: string;
}) {
  const [failedImageUrl, setFailedImageUrl] = useState<string | null>(null);
  const showImage = Boolean(imageUrl && failedImageUrl !== imageUrl);

  return (
    <span
      className={cn(
        "relative flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-full border border-border/70 bg-muted text-3xs font-semibold tracking-tight text-muted-foreground ring-2 ring-[var(--channel-canvas)]",
        className,
      )}
      title={label}
      aria-hidden
    >
      {showImage ? (
        <img
          src={imageUrl ?? undefined}
          alt=""
          className="size-full object-cover"
          referrerPolicy="no-referrer"
          onError={() => setFailedImageUrl(imageUrl)}
        />
      ) : (
        initials
      )}
    </span>
  );
}
